import SectionCard from '../components/SectionCard';

function SettingsPage() {
  return (
    <div className="page-grid">
      <SectionCard title="Конфигурация проекта" subtitle="Основные настройки системы и коммуникаций">
        <form className="settings-form">
          <label>
            Название проекта
            <input type="text" defaultValue="TopTopAff" />
          </label>
          <label>
            Email поддержки
            <input type="email" defaultValue="support@toptopaff.com" />
          </label>
          <label>
            Валюта
            <select defaultValue="USD">
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="UAH">UAH</option>
            </select>
          </label>
          <button type="submit" className="accent-button">
            Сохранить изменения
          </button>
        </form>
      </SectionCard>
    </div>
  );
}

export default SettingsPage;